import { render, staticRenderFns } from "./StatisticsDocView.vue?vue&type=template&id=c435e9fc&"
import script from "./StatisticsDocView.vue?vue&type=script&lang=js&"
export * from "./StatisticsDocView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports